export default function stripTooltipText(el) {
  const clone = el.cloneNode(true); // keep DOM intact
  clone.querySelectorAll(".tooltiptext").forEach(tip => tip.remove());
  return clone.textContent.trim();
}
